// Results rows arrive with the stored id (`wwPipe#123`). The grid shows the part
// after the prefix, but per-asset endpoints (e.g. /risk/results/breakdown) need
// the stored id, so keep it as RAW_ASSET_ID rather than rebuilding it later.
export const withDisplayAssetId = <T extends { ASSET_ID: string }>(
	row: T,
): T & { RAW_ASSET_ID: string } => ({
	...row,
	RAW_ASSET_ID: row.ASSET_ID,
	ASSET_ID:
		row.ASSET_ID.indexOf('#') > 0
			? row.ASSET_ID.split('#')[1]
			: row.ASSET_ID,
});

// The id per-asset risk endpoints expect: `${assetType}#${id}`, matching the
// stored ASSET_ID. Adds the prefix only when it isn't already there.
export const toStoredAssetId = (
	assetType: string,
	row: { ASSET_ID: string; RAW_ASSET_ID?: string },
): string => {
	const id = row.RAW_ASSET_ID ?? row.ASSET_ID;
	if (!assetType || id.startsWith(`${assetType}#`)) return id;
	return `${assetType}#${id}`;
};
